<template>
  <ContentFrame
    :themeColor="computedTopicColor"
    :title="computedTitle"
  >
    <ContentTile
      :themeColor="computedTopicColor"
      :title="$t('goals.t1.title')"
      :textArray="[$t('goals.t1.p0'), $t('goals.t1.p1'), $t('goals.t1.p2')]"
    />
    <ContentImageTile
      imageSource="/img/schulhaus/11.jpg"
    />
    <ContentTile
      :themeColor="computedTopicColor"
      :title="$t('goals.t2.title')"
      :textArray="[$t('goals.t2.p0'), $t('goals.t2.p1')]"
    />
    <ContentTile
      :themeColor="computedTopicColor"
      :title="$t('goals.t3.title')"
      :textArray="[$t('goals.t3.p0'), $t('goals.t3.p1'), $t('goals.t3.p2'), $t('goals.t3.p3')]"
    />
    <ContentContainer
      v-if="computedPrinciples.length > 0"
      :themeColor="computedTopicColor"
      :title="$t('goals.principles.title')"
    >
      <ContentImageTile
        v-for="(principle, i) in computedPrinciples"
        :key="i"
        embedded
        :title="principle.title"
        :themeColor="principle.themeColor"
        :backgroundColor="principle.backgroundColor"
      />
    </ContentContainer>
    <ContentContainer
      :themeColor="computedTopicColor"
      :title="$t('goals.standards.title')"
      :subtitle="$t('goals.standards.subtitle')"
    >
      <ContentTile
        embedded
        :themeColor="computedTopicColor"
        :title="$t('goals.standards.t1.title')"
        :textArray="[$t('goals.standards.t1.p0'), $t('goals.standards.t1.p1'), $t('goals.standards.t1.p2'), $t('goals.standards.t1.p3')]"
      />
      <ContentTile
        embedded
        :themeColor="computedTopicColor"
        :title="$t('goals.standards.t2.title')"
        :textArray="[$t('goals.standards.t2.p0'), $t('goals.standards.t2.p1')]"
      />
      <ContentTile
        embedded
        :themeColor="computedTopicColor"
        :title="$t('goals.standards.t3.title')"
        :textArray="[$t('goals.standards.t3.p0'), $t('goals.standards.t3.p1'), $t('goals.standards.t3.p2')]"
      />
      <ContentTile
        embedded
        :themeColor="computedTopicColor"
        :title="$t('goals.standards.t4.title')"
        :textArray="[$t('goals.standards.t4.p0'), $t('goals.standards.t4.p1'), $t('goals.standards.t4.p2'), $t('goals.standards.t4.p3'), $t('goals.standards.t4.p4'), $t('goals.standards.t4.p5')]"
      />
      <ContentTile
        embedded
        :themeColor="computedTopicColor"
        :title="$t('goals.standards.t5.title')"
        :textArray="[$t('goals.standards.t5.p0'), $t('goals.standards.t5.p1'), $t('goals.standards.t5.p2')]"
      >
        <div
          slot="content"
        >
          <ul>
            <li>{{ $t('goals.standards.t5.li0') }}</li>
            <li>{{ $t('goals.standards.t5.li1') }}</li>
            <li>{{ $t('goals.standards.t5.li2') }}</li>
            <li>{{ $t('goals.standards.t5.li3') }}</li>
            <li>{{ $t('goals.standards.t5.li4') }}</li>
            <li>{{ $t('goals.standards.t5.li5') }}</li>
            <li>{{ $t('goals.standards.t5.li6') }}</li>
            <li>{{ $t('goals.standards.t5.li7') }}</li>
            <li>{{ $t('goals.standards.t5.li8') }}</li>
          </ul>
          <br>
          {{ $t('goals.standards.t5.extra0') }}
          <br><br>
          {{ $t('goals.standards.t5.extra1') }}
          <br><br>
          {{ $t('goals.standards.t5.extra2') }}
        </div>
      </ContentTile>
    </ContentContainer>
  </ContentFrame>
</template>

<script>
import { mapGetters } from 'vuex'
import { PRINCIPLE_COLORS, HIGH_CONTRAST_COLOR } from '@/plugins/colors'

import ContentFrame from '@/views/components/ContentFrame.vue'
import ContentContainer from '@/views/components/ContentContainer.vue'
import ContentTile from '@/views/components/ContentTile.vue'
import ContentImageTile from '@/views/components/ContentImageTile.vue'

export default {
  name: 'Goals',
  components: {
    ContentFrame,
    ContentContainer,
    ContentTile,
    ContentImageTile
  },
  data () {
    return { }
  },
  computed: {
    ...mapGetters([
      'menuData',
      'highContrast'
    ]),
    computedTopicColor () {
      return this.menuData.goals.color
    },
    computedTitle () {
      return this.menuData.goals.title
    },
    computedPrinciples () {
      const images = [
        '/img/prinzipien/verlaesslichkeit.png',
        '/img/prinzipien/verlaesslichkeit.png',
        '/img/prinzipien/verlaesslichkeit.png',
        '/img/prinzipien/verlaesslichkeit.png',
        '/img/prinzipien/verlaesslichkeit.png',
        '/img/prinzipien/verlaesslichkeit.png'
      ]
      return PRINCIPLE_COLORS.map((color, i) => ({
        title: this.$t(`goals.principles.p${i}`),
        themeColor: this.menuData.goals.color,
        imageSource: images[i],
        backgroundColor: this.highContrast ? HIGH_CONTRAST_COLOR : color
      }))
    }
  }
}
</script>

<style scoped>
</style>
